export const WHATSAPP_CTA_HREF = "https://wa.me/93796722464?text=سلام";
export const SNONO_ANDROID_CTA_HREF = "https://play.google.com/store/apps/details?id=com.SnonoConnect&hl=en";
export const SNONO_IOS_CTA_HREF = "https://apps.apple.com/us/app/snonoconnect/id1639772782";
export const BUILTIN_CTA_HREFS = [
    WHATSAPP_CTA_HREF,
    SNONO_ANDROID_CTA_HREF,
    SNONO_IOS_CTA_HREF,
];
/** Maximum URLs in public `allowedCtaUrls` (built-ins + owner-approved custom). */
export const PUBLIC_ALLOWED_CTA_URLS_MAX = 32;
/** Canonical public CTA allowlist for captive portal client validation. */
export function buildPublicAllowedCtaUrls(approvedCustomUrls = []) {
    const seen = new Set();
    const result = [];
    for (const raw of [...BUILTIN_CTA_HREFS, ...approvedCustomUrls]) {
        const trimmed = raw.trim();
        if (!trimmed || !isHttpsUrl(trimmed) || seen.has(trimmed))
            continue;
        seen.add(trimmed);
        result.push(trimmed);
        if (result.length >= PUBLIC_ALLOWED_CTA_URLS_MAX)
            break;
    }
    return result;
}
export const CTA_TYPES = ["whatsapp", "snono_android", "snono_ios", "custom_https"];
export const CTA_TYPE_HREF = {
    whatsapp: WHATSAPP_CTA_HREF,
    snono_android: SNONO_ANDROID_CTA_HREF,
    snono_ios: SNONO_IOS_CTA_HREF,
};
export function isHttpsUrl(value) {
    try {
        const url = new URL(value);
        return url.protocol === "https:";
    }
    catch {
        return false;
    }
}
export function isAllowedCtaHref(href, approvedCustomUrls = []) {
    const trimmed = href.trim();
    if (!isHttpsUrl(trimmed))
        return false;
    if (BUILTIN_CTA_HREFS.includes(trimmed))
        return true;
    return approvedCustomUrls.some((u) => u.trim() === trimmed);
}
export function resolveCtaHref(ctaType, customHref, approvedCustomUrls = []) {
    if (!ctaType)
        return null;
    if (ctaType === "custom_https") {
        const href = (customHref ?? "").trim();
        return isAllowedCtaHref(href, approvedCustomUrls) ? href : null;
    }
    return CTA_TYPE_HREF[ctaType];
}
//# sourceMappingURL=cta.js.map